import { SaleSource } from "@towersystems/roam-common/lib/generated-types";

export const SALE_TYPE_FILTER_OPTIONS = [
  {
    id: "SALE",
    name: "Sale",
  },
  {
    id: "LAYBY",
    name: "Layby",
  },
  {
    id: "QUOTE",
    name: "Quote",
  },
  {
    id: "INVOICE",
    name: "Invoice",
  },
];

export const SALE_SOURCE_FILTER_OPTIONS = [
  {
    id: SaleSource.WEB_REGISTER,
    name: "Point of Sale (Web)",
  },
];
